import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApiError } from './api/envelope';
import { LocaleCatalogLoader } from './i18n/LocaleCatalogLoader';
import { AppRoutes } from './ui/AppRoutes';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      /*
       * 401 ve 403 TEKRARLANMAZ: istemci zaten bir kez token yeniledi
       * (api/client.ts); yenileme de düştüyse tekrar denemek yalnızca oran
       * sınırını (SEOAI-53) tüketir. 4xx genel olarak kullanıcı hatasıdır.
       */
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;

        return failureCount < 2;
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* Dil kataloğu public uçtan; giriş yapılmadan da dil seçilebilmeli. */}
        <LocaleCatalogLoader />
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
